import { createReducer } from '@reduxjs/toolkit'
import { TickerTuple } from '../../api/v1/market'
import {
  updateAllTickerAction,
  updateLastBarAction,
  updateTradeTypeAction,
} from './actions'
import { MarketState, Ticker } from './types'
import { getMarketPriceConfigAction } from './actions/getMarketPriceConfigActions'
import { getContractInformationAction } from './actions/getContractInformationActions'
import { getMarketPriceAction } from './actions/getMarketPriceActions'
import { getMarketBarAction } from './actions/getMarketBarActions'
import { getAllTickerAction } from './actions/getAllTickerActions'
import { getMarketIndexesAction } from './actions/getMarketIndexesActions'
import { getMarketTradesAction } from './actions/getMarketTradesActions'
import { getExternalPricesAction } from './actions/getExternalPrices'

const initialState: MarketState = {
  trade: 0,
  trades: {
    convertTokens: [],
    spotsSymbols: [],
    contractsCurrencies: [],
    contractsSymbols: [],
    indexes: [],
    spotsCurrencies: [],
    riskLimits: [],
    currencies: [],
    tokenMappingList: [],
    chains: {},
  },
  indexes: {
    nextFundingTime: [0, '0'],
  },
  tickers: {},
  marketBar: {
    time: 0,
    open: 0,
    high: 0,
    low: 0,
    close: 0,
    volume: 0,
    value: 0,
  },
  marketPrice: {
    LONG: {},
    SHORT: {},
  },
  marketPriceConfig: undefined,
  lastBar: {
    time: 0,
    open: 0,
    close: 0,
    low: 0,
    high: 0,
    volume: 0,
    isBarClosed: false,
  },
  contractInformation: {},
  externalPrices: {},
}

function parseTicker(ticker: TickerTuple): Ticker {
  return {
    timestamp: ticker[0],
    open: ticker[1],
    high: ticker[2],
    low: ticker[3],
    close: ticker[4],
    volume: ticker[5],
    value: ticker[6],
    percent: ((ticker[4] - ticker[1]) / ticker[1]) * 100,
  }
}

export default createReducer<MarketState>(initialState, (builder) => {
  builder
    .addCase(updateTradeTypeAction, (state, { payload }) => {
      state.trade = payload
    })
    .addCase(getMarketTradesAction.fulfilled, (state, { payload }) => {
      state.trades = payload
    })
    .addCase(getMarketIndexesAction.fulfilled, (state, { payload }) => {
      state.indexes = payload
    })
    .addCase(getAllTickerAction.fulfilled, (state, { payload }) => {
      for (const key in payload) {
        state.tickers[key] = parseTicker(payload[key])
      }
    })
    .addCase(updateAllTickerAction, (state, { payload }) => {
      for (const key in payload) {
        state.tickers[key] = parseTicker(payload[key])
      }
    })
    .addCase(getMarketBarAction.fulfilled, (state, { payload }) => {
      const { results } = payload
      if (results.length) {
        const data = results[results.length - 1]
        state.marketBar = {
          time: data[0],
          open: data[1],
          high: data[2],
          low: data[3],
          close: data[4],
          volume: data[5],
          value: data[6],
        }
      }
    })
    .addCase(getMarketPriceAction.fulfilled, (state, { payload }) => {
      state.marketPrice = payload
    })
    .addCase(updateLastBarAction, (state, { payload }) => {
      state.lastBar = { ...payload, isBarClosed: false }
    })
    .addCase(getContractInformationAction.fulfilled, (state, { payload }) => {
      state.contractInformation = payload
    })
    .addCase(getMarketPriceConfigAction.fulfilled, (state, { payload }) => {
      state.marketPriceConfig = payload
    })
    .addCase(getExternalPricesAction.fulfilled, (state, { payload }) => {
      state.externalPrices = payload
    })
})
